
import { CiudadService } from './../services/ciudad.service';
import { Component, ViewChild } from '@angular/core';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { MovFechaService } from '../services/movfecha.service';
import { IMovimientosFecha } from '../models/movfecha';
import { Table } from 'primeng/table';
import { AuthService } from '../services/auth.service';
import ICredencialUsuario from '../models/credencial';
import { IResultadoGeneral } from '../models/resultadogeneral';
import { IMes } from '../models/mes';
import { ICiudad } from '../models/ciudad';
import { RecursosService } from '../services/recursos.service';
import { IRecursoCombustible } from '../models/recurso_combustible';
import { IRecursosMaster } from '../models/recursos_master';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IRecursosFechas } from '../models/recursosFechas';

@Component({
  selector: 'app-consultaoperacion',
  templateUrl: './consultaoperacion.component.html',
  styleUrls: ['./consultaoperacion.component.scss']
})
export class ConsultaoperacionComponent {
  lstMovimientos: IMovimientosFecha[] = [];
  listCombustible: IRecursoCombustible[] = [];  

  loading: boolean = false;
  fecha_dia: any = null;
  fecha_fin: any = null;
  mostrarbtnLimpiarFiltro: boolean = false;
  loading_combustible:boolean=false;
  kim_inicial_carga:number=0;
  kim_final_carga:number=0;
  messageFinCombustible:string = '';
  dspRecursos:boolean=false;

  @ViewChild('dt1') dt!: Table;
  //Registro
  user: ICredencialUsuario = {};

  recurso: IRecursosMaster = {
      idx_pao_diario_unidades: 0,
      id_unidad_transporte: 0,
      num_economico: '',
      listCasetas: [],
      listCombustible: [],
      kim_inicial: 0,
      kim_final: 0,
      cod_usuario_registro_combustible: '',
      clv_fin_ruta: 0,
      total_casetas: 0,
      total_combustible: 0,
      clv_fin_casetas: 0,
      clv_fin_combustible: 0
    };

  resultado: IResultadoGeneral = {
    clv_estatus: 0,
    messageDetails: ''
  };

  fecha_del_dia: any = null;
  fecha_del_recurso: any;
  //Fecha no se modifica
  fecha_final_dia!: Date;
  //Fecha para restar 3 dias
  fecha_minus3 !: Date;
  habilitar_tres_dias: boolean = true;
  texto_fecha_recurso: any = null;

  fecha_dia_real: any = null;

  meses: IMes[] = [
    { num_mes: 1, nombre: "Enero" },
    { num_mes: 2, nombre: "Febrero" },
    { num_mes: 3, nombre: "Marzo" },
    { num_mes: 4, nombre: "Abril" },
    { num_mes: 5, nombre: "Mayo" },
    { num_mes: 6, nombre: "Junio" },
    { num_mes: 7, nombre: "Julio" },
    { num_mes: 8, nombre: "Agosto" },
    { num_mes: 9, nombre: "Septiembre" },
    { num_mes: 10, nombre: "Octubre" },
    { num_mes: 11, nombre: "Noviembre" },
    { num_mes: 12, nombre: "Diciembre" }];
    // dbsReportes: boolean = false;
    // lstRendimientoColaboradorReporte:any = [];
    lstCiudades: ICiudad[] = [];
    selectedCiudad: ICiudad ={
      id: 0,
      nombre: '',
      clave_Estado: '',
      id_ciudad_principal: 0
    };
    formfechas: FormGroup = new FormGroup({
      idx: new FormControl(0),
      clv_fin_sp: new FormControl(0),
      cod_usuario_fin_sp: new FormControl(''),
      fecha_fin_sp: new FormControl(null,Validators.required)
    });
    dgfechas:boolean=false;

  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private movfechaService: MovFechaService,
    private auth: AuthService,
    private ciudadService:CiudadService,
    private recursoService:RecursosService
  ) {
    this.cargarInformacionUsuario();
  }

  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  ngOnInit(): void {
    this.inicializarFechasFormateadas();
    this.cargarListadoCiudades();
  }

  cargarListadoCiudades() {
    this.ciudadService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudades = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <Ciudades>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  inicializarFechasFormateadas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    this.fecha_dia = dateFormat;
    this.fecha_del_dia = new Date(dateFormat + 'T00:00:00');
    //Fecha que no se modifica
    this.fecha_final_dia = new Date(dateFormat + 'T00:00:00');
    //Fecha para restar los 3 dias
    let minus3days = new Date(this.fecha_final_dia);
    this.fecha_minus3 = new Date(minus3days.setDate(new Date(minus3days).getDate() - 4));

    //Fecha del dia real, no se mueve
    this.fecha_dia_real = dateFormat;
  }

  cargarInformacionPorFecha(fecha: string, fecha_fin: string) {
    let fecha_fin_cast = fecha_fin == null ? '1900-01-01' : fecha_fin;
    this.lstMovimientos = [];
    this.loading = true;
    if (fecha == null) {
      this.mostrarDialogoInformativo('<b>Aviso</b> Es necesario seleccionar <b>Fecha</b> de Operación a Filtrar');
    } else {
      //Cargar info del excel
      this.movfechaService.getListadoDeMovimientosFecha_seguridad(fecha, fecha_fin_cast, this.user.cod).subscribe((resp) => {
        this.lstMovimientos = resp;

        if (!this.lstMovimientos.length || typeof this.lstMovimientos === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion con la Fecha Seleccionada de Operaciones');
        }
        this.mostrarbtnLimpiarFiltro = true;
        this.loading = false;
      },
        (error) => {
          this.loading = false;
          this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Informacion de Operacion Diaria');
        });
    }
  }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '. <b>Contacte al Administrador.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
  }

  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
    this.messageService.clear();
  }

  mostrarRecursos(data: IMovimientosFecha){
    this.loading_combustible=true;

    this.recursoService.getListadoRecursos(data.idx, data.id_unidad_transporte, data.num_economico).subscribe((resp) => {
      this.recurso = resp[0];
      this.loading_combustible=false;
      this.listCombustible = this.recurso.listCombustible.filter((data) => data.cod_usuario_registro != '0000');
      this.messageFinCombustible = 
        this.recurso.clv_fin_combustible == 0 ? 'Sin Finalizar Combustible' : 'Combustible Finalizado';

      if(this.listCombustible.length>0){
        //se pone el kilometro final del ultimo registro como inicial
        let kim_final:number=this.listCombustible.at(-1)?.kim_final_carga!;
        let kim_inicial:number=this.listCombustible.at(0)?.kim_inicial_carga!;
        this.kim_inicial_carga = kim_inicial;
        this.kim_final_carga = kim_final;
        this.dspRecursos = true;
        this.loading_combustible=false;
      } else {
        this.mostrarDialogoInformativo('La ruta <b>NO</b> cuenta con cargas de combustible, <b>Estatus: '
          +this.messageFinCombustible+'</b>.');
        this.kim_inicial_carga = 0;
        this.kim_final_carga = 0;
      }
    },
    (error)=>{
      this.loading_combustible=false;
    });
  }

  LimpiarFiltro() {
    this.lstMovimientos = [];
    this.fecha_dia = null;
    this.fecha_fin = null;
    this.limpiarFiltrosTabla();
    this.mostrarbtnLimpiarFiltro = false;
  }

  limpiarFiltrosTabla() {
    this.dt.clear();
  }

  cancelarModal() {
    this.dspRecursos = false;
    this.listCombustible = [];
  }
  loading_fechas:boolean=false;
  setFechasRecursos(data: IRecursosFechas) {
  const formatForDatetimeLocal = (f: Date | string | null): string | null => {
    if (!f) return null;
    const d = new Date(f);
    if (isNaN(d.getTime())) return null;
    // Construir string YYYY-MM-DDTHH:mm
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  };

  this.formfechas.patchValue({
    idx: data.idx,
    fecha: formatForDatetimeLocal(data.fecha),
    fecha_fin_casetas: formatForDatetimeLocal(data.fecha_fin_casetas),
    fecha_fin_combustible: formatForDatetimeLocal(data.fecha_fin_combustible),
    fecha_fin_ruta: formatForDatetimeLocal(data.fecha_fin_ruta),
    fecha_fin_operacion: formatForDatetimeLocal(data.fecha_fin_operacion),
    clv_fin_combustible: data.clv_fin_combustible,
    clv_fin_casetas: data.clv_fin_casetas,
    clv_fin_ruta: data.clv_fin_ruta,
    clv_fin_operacion: data.clv_fin_operacion
  });
}
  
  mostrarFechasFin(idx: number) {
    this.loading_fechas = true;

    let obj_sp = this.lstMovimientos.find(x => x.idx == idx);
    //  this.formfechas.patchValue({
    //     idx: obj_sp!= undefined?obj_sp.idx:0,
    //     clv_fin_sp: obj_sp!= undefined?obj_sp.clv_fin_sp:0,
    //     cod_usuario_fin_sp: obj_sp!= undefined?obj_sp.cod_usuario_fin_sp:'',
    //     fecha_fin_sp: obj_sp!= undefined?obj_sp.fec_fin_sp:''
    //   });
    if(obj_sp == undefined)
      this.formfechas.patchValue({
        idx: 0,
        clv_fin_sp: 0,
        cod_usuario_fin_sp: '',
        fecha_fin_sp: null
      });
    else
      this.formfechas.patchValue({
      idx: obj_sp.idx,
      clv_fin_sp: obj_sp.clv_fin_sp,
      cod_usuario_fin_sp: obj_sp.cod_usuario_fin_sp,
      fecha_fin_sp: obj_sp.clv_fin_sp==1?obj_sp.fec_fin_sp:null
      }); 
      
    if(obj_sp!.clv_fin_sp==0)
      this.dgfechas = true;
    else{
      this.guardarFechas();
      this.loading_fechas = false;
    }
    // this.movfechaService.getFechaRecursos(idx).subscribe({
    //   next: (resp) => {
    //     if (resp && resp.idx !== 0) {
    //       this.setFechasRecursos();
    //     } else {
    //       this.messageService.add({
    //         key: 'msj',
    //         severity: 'error',
    //         summary: 'Error en <Cargar Fechas Servicio>',
    //         detail: 'Contacte al Administrador del Sitio'
    //       });
    //     }
    //   },
    //   error: () => {
    //     this.messageService.add({
    //       key: 'msj',
    //       severity: 'error',
    //       summary: 'Error en <Cargar Fechas Servicio>',
    //       detail: 'Contacte al Administrador del Sitio'
    //     });
    //   },
    //   complete: () => {
    //     this.loading_fechas = false;
    //     this.dgfechas = true;
    //   }
    // });
  }
  guardarFechas() { 
    const formValues = this.formfechas.value;
  
    const formatForBackend = (f: string | null): string | null => {
      if (!f) return null;
      // Agrega segundos, datetime-local solo tiene HH:mm
      return f + ':00';
    };
  
    const data = {
      idx: formValues.idx,
      clv_fin_sp: formValues.clv_fin_sp==0?1:0,
      fecha_fin_sp: formatForBackend(formValues.fecha_fin_sp),
      cod_usuario_fin_sp: this.user.cod || '0999',
    };
    let obj = this.formfechas.value;
    let mssg = obj.clv_fin_sp ==1? 
      'Esta seguro que desea modificar las fechas correspondientes a <b>Fecha Fin Seguridad Patrimonial</b>?'
      :'Esta seguro de <b>finalizar</b> la ruta por <b>Seguridad Patrimonial</b>?';
    this.confirmationService.confirm({
      message: mssg,
      header: 'Confirmacion de modificación de fechas',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.movfechaService.updateFechaSegPat(data).subscribe(resp => {
          if (typeof resp === 'undefined' || resp.clv_estatus == -2)
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Rechazado', detail: resp.messageDetails });
          else if(resp.clv_estatus=-3){
            this.dgfechas = false;
            this.messageService.add({ key: 'msj', severity: 'info', summary: 'Informativo', detail: resp.messageDetails });
            this.cargarInformacionPorFecha(this.fecha_dia, this.fecha_fin);
          }
          else if(resp.clv_estatus=1){
            this.dgfechas = false;
            this.messageService.add({ key: 'msj', severity: 'success', summary: 'Confirmación', detail: resp.messageDetails });
            this.cargarInformacionPorFecha(this.fecha_dia, this.fecha_fin);
          }
        });
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Rechazado', detail: 'Se ha Rechazado la operación' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Se ha Cancelado la operación' });
            break;
        }
      }
      , key: "kc"
    });
  }
  cancelarGestionFechas() {
    this.dgfechas = false;
    this.formfechas.reset();
  }

  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
}
